import React from 'react';
import { withPermissionsProps } from '../../../Utilities/hoc/withPermissions';
import { ISmartProps, IOpenInterface } from './types';
import { View } from './view';

type EpoType = ISmartProps & withPermissionsProps;

export const Link = (props: EpoType & IOpenInterface) => {
	return <View {...props} />;
};
